export default __webpack_public_path__ + "static/media/Q1.24190584.png";